import React from 'react';
import { Translate } from "react-localize-redux";
import classnames from 'classnames';
import { connect } from 'react-redux';

class MainHeader extends React.Component {
    render() {
        return (
            <div className={classnames('sr-ribbon is-sticky', { 'tinted': this.props.tinted, 'shadowed': this.props.shadowed })} style={{ top: this.props.charts || this.props.user.authentication.limitedUser ? '0px' : null, right: this.props.right }}>
                <div className="main-header">
                    <span>
                        { this.props.label !== undefined && <Translate id={this.props.label}/> }
                        { this.props.raw !== undefined && this.props.raw }
                        { this.props.flag !== undefined && <sup><img src={this.props.flag} className='sup-flag' /></sup>}
                    </span>
                </div>
            </div>
        )
    }
}

export default connect(state => ({ user: state.userContext }))(MainHeader)